{
  "GENERAL": {
    "CLOSE": "Stäng",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Sök",
      "EMPTY_STATE": "Inga resultat hittades"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Minst {count} krävs"
  }
}
